import { gql } from "graphql-request";

const SERVER_GET_VACATION_CONFIG_CONTRACT = gql`
  query SERVER_GET_VACATION_CONFIG_CONTRACT($userContractId: ID!) {
    vacationConfig(userContractId: $userContractId) {
      id
      vacationPeriodData {
        monthsCertificateBeforeEmployer
        periodOfCertificateDelivery
        firstPeriodWithProgressive
        vacationPeriods {
          id
          number
          initialDate
          finalDate
          legalDays
          progressiveDays
          additionalDays
          legalDaysPool
          progressiveDaysPool
          additionalDaysPool
          description
        }
      }
      art67
      hasHistory
      progressiveMonths
      progressiveVacationInitialDate
      progressiveVacationCertificateDate
      progressiveVacationCertificateDeliveryDate
      recognizedVacationInitialDate
      legalDaysRecognized
      legalDaysByContract
      additionalDaysAnual
      legalBalance
      progressiveBalance
      additionalBalance
      balanceAdjustmentDate
      user {
        id
        fullname
      }
      userContract {
        id
        status
      }
      progressiveVacationFile {
        id
        url
      }
    }
    contractVacations(userContractId: $userContractId) {
      id
      comment
      startDate
      endDate
      responseStatus
      response
      applicationStartDate
      applicationEndDate
      requestDate
      responseDate
      isHistoric
      halfDay
      responseStatusValues
      progressiveDays
      legalDays
      additionalDays
      voucherFile {
        id
        url
      }
      user {
        id
        rut
        fullname
        firstname
        paternalLastname
        area
        branchOffice
        jobTitle
        avatar {
          id
          url
        }
      }
      userContract {
        id
        initialDate
        businessId
      }
      authorizedBy {
        id
        fullname
        firstname
        paternalLastname
        avatar {
          id
          url
        }
      }
    }
  }
`;

export default SERVER_GET_VACATION_CONFIG_CONTRACT;
